import { useScreen } from '@hooks'
import { useTheme } from '@react-navigation/native'
import { getCommonStyles } from '@utils'
import React, { ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'

type OnBoardingProps = {
  children: ReactNode
}

export const OnBoarding = ({
  children,
}: OnBoardingProps): React.ReactElement => {
  const theme = useTheme()
  const commonStyles = getCommonStyles(theme)
  const { isMobile } = useScreen()
  
  return (
      <View style={[!isMobile && commonStyles.flexMaxAuth, styles.container]}>
        {children}
      </View>
  ) 
}

const styles = StyleSheet.create({
    container: {
      flex: 1,
      width: '100%',
    },
  })


